module.exports = __webpack_public_path__ + "static/media/Rainbow Paper.7d244db6.ttf";